// GENERATED — do not edit. Imports the iconNode from the sibling .data.ts (lucide ISC).

import { createIcon } from "../../../internal/createIcon";
import { iconNode } from "./LockKeyholeIcon.data";

export const LockKeyholeIcon = createIcon("LockKeyholeIcon", iconNode);
